import React from 'react';
import PropTypes from 'prop-types';
import { useAppContext } from 'context/AppContext';
import routes from 'routes';

import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { formatShortDateTime } from 'helpers/DateHelper';
import { Link } from 'react-router-dom';

const ShowingList = ({ bookingId, showings }) => {
    const { appContext } = useAppContext();

    if(showings.length === 0) {
        return null;
    }

    return (
        <Box>
            <Typography variant="h6" display="block">Showings</Typography>

            <ul>
                {
                    showings.map(showing =>
                        (
                            <li key={showing.id}>
                                <Link to={routes.admin.updateShowing.replace(':bookingId', bookingId).replace(':showingId', showing.id)}>
                                    {
                                        formatShortDateTime(showing.startTime, appContext)
                                    }
                                    &ndash;
                                    {
                                        formatShortDateTime(showing.endTime, appContext)
                                    }
                                </Link>
                            </li>
                        )
                    )
                }
            </ul>
        </Box>
    );
};

ShowingList.propTypes = {
    bookingId: PropTypes.number.isRequired,
    showings: PropTypes.array.isRequired
};

export default ShowingList;
